<template>
  <section class="main-banner__wrapper">
    <su-attestat-modal
      v-if="showAttestatModal"
      @close="showAttestatModal = false"
    />

    <div :class="`main-banner main-banner--${pageClass || ''}-class`">
      <!--<div class="main-banner__cheap">-->
      <!--  <button-->
      <!--    class="m-btn"-->
      <!--    @click="showAttestatModal = true"-->
      <!--  >-->
      <!--    <span>гос. аттестат</span>-->
      <!--  </button>-->
      <!--  <span>поддержка 24/7</span>-->
      <!--  <span>сильные преподаватели</span>-->
      <!--</div>-->
      <h1
        class="main-banner__title"
        v-html="title || 'домашняя школа для 1‑11&nbsp;классов'"
      />

      <h2
        v-if="subtitle"
        class="main-banner__subtitle"
        v-html="subtitle"
      />
      <h2
        v-else
        class="main-banner__subtitle"
      >
        <span>
          Свобода учиться где&nbsp;угодно: московский аттестат&nbsp;гос. образца, куратор,
          наставник и&nbsp;школьный психолог, онлайн-аттестация дома в&nbsp;комфорте.
        </span>
        Познакомьтесь с&nbsp;платформой и&nbsp;преподавателями
      </h2>

      <button
        class="main-banner__btn m-btn"
        @click="openModal(MODAL_TYPES.demo)"
      >
        {{ schoolCeny3Page ? 'учиться бесплатно' : 'получить доступ' }}
      </button>

      <span class="main-banner__cheap">
        7 дней бесплатно
      </span>

      <button
        class="m-btn main-banner__to-down"
        @click="scrollTo('.main-certificate')"
      >
        <img
          src="/v2/catalog/repetitor/banner/arrow-down.svg"
          alt="down"
        >
      </button>
    </div>

    <school-new-banner-blocks2 />
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import scrollTo from '~/utils/scrollTo';
import { MODAL_TYPES } from '../common/AppHeader/data';

import SchoolNewBannerBlocks2 from './SchoolNewBannerBlocks2.vue';
import SuAttestatModal from '../school-university/SuAttestatModal.vue';

export default {
  name: 'SchoolNewBanner',
  components: {
    SuAttestatModal,
    SchoolNewBannerBlocks2,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    pageClass: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    showAttestatModal: false,
    MODAL_TYPES,
    scrollTo,
  }),
  computed: {
    schoolCeny3Page() {
      return this.$route.name === 'online-school-ceny-3';
    },
  },
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style lang="scss" scoped>

.main-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(var(--scale) * 512);
  padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
  border-radius: calc(var(--scale) * 60);

  background-image: url("/v2/school-new/banner/bg.webp");
  background-size: cover;
  background-position: right bottom;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 400);
    padding: calc(var(--scale) * 16) calc(var(--scale) * 8) calc(var(--scale) * 8);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/school-new/banner/bg-tablet.webp");
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 560);
    background-image: url("/v2/school-new/banner/bg-mob.webp");
    background-position: center;
  }

  &__title  {
    max-width: calc(var(--scale) * 1025);
    margin-bottom: calc(var(--scale) * 20);

    text-indent: calc(var(--scale) * 8);
    margin-left: calc(-1 * var(--scale) * 8);

    font-family: 'Onest', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: calc(var(--scale) * 120);
    line-height: 80%;
    letter-spacing: -0.06em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 334);
      margin-bottom: calc(var(--scale) * 8);
      padding-inline: calc(var(--scale) * 8);
      text-indent: calc(var(--scale) * 2);
      margin-left: calc(-1 * var(--scale) * 2);
      font-size: calc(var(--scale) * 54);
      letter-spacing: -0.02em;
      line-height: 90%;
    }
  }

  &__subtitle {
    max-width: calc(var(--scale) * 869);

    font-family: 'Onest', sans-serif;
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 110%;
    color: #FFFFFF;

    span {
      opacity: 0.6;
    }

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 334);
      padding-inline: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 16);
      letter-spacing: -0.02em;
    }
  }

  &__btn {
    margin-top: auto;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 56);
    background-color: #5237E6;
    border-radius: calc(var(--scale) * 32);
    transition: 200ms;

    font-family: 'Onest', sans-serif;
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 30);
      width: 100%;
      border-radius: calc(var(--scale) * 24);
      font-size: calc(var(--scale) * 18);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #846EFB;
      }
    }
  }

  &__cheap {
    position: absolute;
    left: calc(var(--scale) * 214);
    bottom: calc(var(--scale) * 20);

    padding: calc(var(--scale) * 8) calc(var(--scale) * 16) calc(var(--scale) * 10);
    background-color: #FFFFFF;
    border-radius: calc(var(--scale) * 40);
    transform: rotate(-5deg);

    font-weight: 500;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #5237E6;

    @include media-down($size-tablet) {
      left: auto;
      right: calc(var(--scale) * 7);
      bottom: calc(var(--scale) * 77);
      transform: rotate(5deg);
      padding: calc(var(--scale) * 4) calc(var(--scale) * 10) calc(var(--scale) * 6);
      font-size: calc(var(--scale) * 14);
    }
  }

  &__to-down {
    width: calc(var(--scale) * 64);
    height: calc(var(--scale) * 64);
    outline: none;

    position: absolute;
    z-index: 2;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);

    background-color: $white-color;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 50%;

    img {
      filter: invert(18%) sepia(52%) saturate(6003%) hue-rotate(248deg) brightness(92%) contrast(95%);
    }

    @include media-down($size-tablet) {
      display: none;
    }
  }

  // class pages
  &.main-banner--5-class {
    background-image: url("/v2/school-new/5/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/5/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/5/banner-mob.webp");
    }
  }

  &.main-banner--6-class {
    background-image: url("/v2/school-new/6/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/6/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/6/banner-mob.webp");
    }
  }

  &.main-banner--7-class {
    background-image: url("/v2/school-new/7/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/7/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/7/banner-mob.webp");
    }
  }

  &.main-banner--8-class {
    background-image: url("/v2/school-new/8/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/8/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/8/banner-mob.webp");
    }
  }

  &.main-banner--9-class {
    background-image: url("/v2/school-new/9/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/9/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/9/banner-mob.webp");
    }
  }

  &.main-banner--10-class {
    background-image: url("/v2/school-new/10/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/10/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/10/banner-mob.webp");
    }
  }

  &.main-banner--11-class {
    background-image: url("/v2/school-new/11/banner.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/school-new/11/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/11/banner-mob.webp");
    }
  }
}

</style>
